import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { allPages } from "@nexxt/app-kit";
import type { SoLineStatus } from "@nexxt/contracts/sales";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api } from "../../api";
import { salesOrderQueries } from "../sales-order/sales-order.queries";

// Server state of the lines of an order (pattern.md §10), by cursor on the line number. Their keys are under the
// order's, so whatever reloads an order reloads its lines too.

const linesOf = api.sales["sales-orders"][":salesOrderId"].lines;

type LinesPage = InferResponseType<typeof linesOf.$get, 200>;
export type SalesOrderLine = LinesPage["items"][number];

export const soLineQueries = {
  list: (salesOrderId: string, status?: SoLineStatus | undefined) =>
    infiniteQueryOptions({
      queryKey: [...salesOrderQueries.of(salesOrderId), "lines", { status }],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          linesOf.$get(
            { param: { salesOrderId }, query: { ...(status && { status }), ...(pageParam && { cursor: pageParam }) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),

  /** Every line of an order, for a dialog to offer them: an order has a few hundred at most. */
  all: (salesOrderId: string) =>
    queryOptions({
      queryKey: [...salesOrderQueries.of(salesOrderId), "lines", "all"],
      queryFn: ({ signal }) =>
        allPages((cursor) =>
          unwrap(
            linesOf.$get(
              { param: { salesOrderId }, query: { limit: "500", ...(cursor && { cursor }) } },
              { init: { signal } },
            ),
          ),
        ),
    }),
};
